import Box from '@mui/material/Box';

// project imports
import Navigation from './Navigation';
import SimpleBar from '../../../../components/third-party/SimpleBar';
import AppWebVersionCaption from '../../../../components/AppWebVersionCaption';
import { useGetMenuMaster } from '../../../../api/menu';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened || false;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', minHeight: 0, height: '100%' }}>
      <SimpleBar
        sx={{
          flex: '1 1 auto',
          minHeight: 0,
          '& .simplebar-content': { display: 'flex', flexDirection: 'column' }
        }}
      >
        <Navigation />
        {/*¡¡ {drawerOpen && <NavCard />} */}
      </SimpleBar>
      <AppWebVersionCaption placement="drawer" drawerOpen={drawerOpen} />
    </Box>
  );
}

